<ion-item [class.invalid]="isInvalid() && isTouched()" class="checkItem">
  <ion-toggle [checked]="value == 'True' || value == 'true'" [disabled]="readonly" #input (ionChange)="onToggleChange()"><label class="label-text">{{obligatorio ? '* ' : ''}}{{label}}</label></ion-toggle>
</ion-item>
